import React, { useState } from 'react';

const APIAdapter = {

    authToken:'',
    quadToken:'',
    refToken:'',
    userId:'',
    // baseURL:'https://island.24livehost.com/API/', Demo
    baseURL:'https://tiq.theloyaltyco.app/api/', // Live
    quadranetURL:'https://loyaltyapi.quadranet.co.uk/',
    // tevalisBaseURL:'https://island.24livehost.com/API/',

    Authenticate:async function(method, params){
        console.log(this.baseURL + method)
        try {
          const response = await fetch(
            this.baseURL + method, {
                method: 'POST',
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(params)
              }
          );

          if (response.status == 200) {
            const json = await response.json();
            // console.log(json)
            return {success: json.success, data:json.data, message:json.message}
        }
        else{
            return {success: false, data:null, message:"Something went wrong, please try again later." + response.error}
        }
        } catch (error) {
            console.log('API call failed')
            console.error(error);
        }
    },

    RefreshToken:async function(method, params){
      // console.log(this.baseURL + method)
      try {
        const response = await fetch(
          this.baseURL + method, {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({"uuid":"", "userId":this.userId, "refToken":this.refToken})
            }
        );

        if (response.status == 200) {
          const json = await response.json();
          // console.log(json)
          return {success: json.success, data:json.data, message:json.message}
      }
      else{
          return {success: false, data:null, message:"Something went wrong, please try again later." + response.error}
      }
      } catch (error) {
          console.log('API call failed')
          console.error(error);
      }
  },

    GET:async function(method){
        // console.log(this.baseURL + method)
        try {
            // console.log('entered for API call')
          const response = await fetch(
            (this.baseURL + method), {
                method: 'GET',
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  'Authorization' : ('Bearer ' + this.authToken)
                }
              }
          );

            if (response.status == 200) {
                const json = await response.json();
                // console.log(json)
                return {success: json.success, data:json.data, message:json.message, tokenExpired:false}
            }
            else if(response.status == 401){
              return {success: false, data:null, message:"Authorization failed.", tokenExpired:true}
            }
            else{
                return {success: false, data:null, message:"Something went wrong, please try again later." + response.error, tokenExpired:false}
            }
        } catch (error) {
            console.log('API call failed')
          console.error(error);
          return {success: false, data:null, message:"Authorization failed.", tokenExpired:true}
        }
    },

    


    POST:async function(method, params){
      console.log(this.baseURL + method)
      // console.log(params)
      try {
          // console.log('entered for API call')
          const response = await fetch(
            this.baseURL + method, {
                method: 'POST',
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  'Authorization' : 'Bearer ' + this.authToken
                },
                body: JSON.stringify(params)
              }
          );
          // console.log('API Status: ' + response.status);
          if (response.status == 200) {
              const json = await response.json();
              // console.log(json);
              if (json.statusCode == "403") {
                return {success: false, data:json.data, message:json.message}
              }
              return {success: json.success, data:json.data, message:json.message}
          }
          else if(response.status == 401){
            return {success: false, data:null, message:"Authorization failed."}
          }
          else{
            return {success: false, data:null, message:"Something went wrong, please try again later." + response.error}
          }
      } catch (error) {
          console.log('API call failed')
          console.error(error);
      }
  },

  GET_QUADRANET:async function(method){
    // console.log(this.baseURL + method)
    try {
        // console.log('entered for API call')
      const response = await fetch(
        (this.quadranetURL + method), {
            method: 'GET',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'Authorization' : ('Bearer ' + this.quadToken)
            }
          }
      );

        if (response.status == 200) {
            const json = await response.json();
            // console.log(json)
            return {success: json.success, data:json, message:json.message, tokenExpired:false}
        }
        else if(response.status == 401){
          return {success: false, data:null, message:"Authorization failed.", tokenExpired:true}
        }
        else{
            return {success: false, data:null, message:"Something went wrong, please try again later." + response.error, tokenExpired:false}
        }
    } catch (error) {
        console.log('API call failed')
      console.error(error);
      return {success: false, data:null, message:"Authorization failed.", tokenExpired:true}
    }
},

  POST_QUADRANET:async function(method, params){
    console.log(this.quadranetURL + method)
    // console.log(params)
    try {
        // console.log('entered for API call')
        const response = await fetch(
          this.quadranetURL + method, {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                //'Authorization' : 'Bearer ' + this.authToken
              },
              body: JSON.stringify(params)
            }
        );
        // console.log('API Status: ' + response.status);
        if (response.status == 200) {
            const json = await response.json();
            // console.log(json);
            if (json.statusCode == "403") {
              return {success: false, data:json.data, message:json.message}
            }
            return {success: true, data:json, message:""}
        }
        else if(response.status == 401){
          return {success: false, data:null, message:"Authorization failed."}
        }
        else{
          return {success: false, data:null, message:"Something went wrong, please try again later." + response.error}
        }
    } catch (error) {
        console.log('API call failed')
        console.error(error);
    }
},

    // Tevalis APIs methods
    GETTevalis:async function(method){
      console.log(this.tevalisBaseURL + method)
      try {
          // console.log('entered for API call')
        const response = await fetch(
          (this.tevalisBaseURL + method), {
              method: 'GET',
              //mode:'no-cors',
              headers: {
                'Accept': 'application/json',
                'Access-Control-Allow-Origin':'*',
                'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
                'Content-Type': 'application/json',
                "CompanyID":"1786",
                "DevID":"LOYALCO20200713_2F8E59F7-887D-437D-B7F8-81B0E35A8B68",
                "Guid":"149cc007-5485-4dea-9d29-3b2b10aa54c2",
                "GUID2":"72b53981-d1a7-47d8-a268-e012a8488710"                
              }
            }
        );

          if (response.status == 200) {
              const json = await response.json();
              // console.log(json)
              return {success: true, data:json, message:"", tokenExpired:false}
          }
          else if(response.status == 401){
            return {success: false, data:null, message:"Authorization failed.", tokenExpired:true}
          }
          else{
            const json = await response.blob(); 
            let blob = new Blob([json], {type: 'text/plain'});

            const resData = await blobToData(blob)
            // console.log(resData);
             
            return {success: false, data:null, message:resData, tokenExpired:false}
          }
      } catch (error) {
          console.log('API call failed')
        console.error(error);
        return {success: false, data:null, message:"Authorization failed.", tokenExpired:true}
      }
  },

  POSTTevalis:async function(method, params){
    // console.log(this.tevalisBaseURL + method)
    try {
        // console.log('entered for API call')
        const response = await fetch(
          this.tevalisBaseURL + method, {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                "Access-Control-Allow-Origin":"*",
                "CompanyID":"1326",
                "DevID":"LOYALCO20200713_2F8E59F7-887D-437D-B7F8-81B0E35A8B68",
                "Guid":"0cc19410-4f65-4fb3-9c71-890deb86572c",
                "GUID2":"5c45891f-5bb4-4032-b7ea-61bc36bd8ee5"
              },
              body: JSON.stringify(params)
            }
        );
        // console.log('API Status: ' + response.status);
        if (response.status == 200) {
          const json = await response.json();
          // console.log(json)
          return {success: true, data:json, message:"", tokenExpired:false}
      }
      else if(response.status == 401){
        return {success: false, data:null, message:"Authorization failed.", tokenExpired:true}
      }
      else{
        const json = await response.blob(); 
        let blob = new Blob([json], {type: 'text/plain'});

        const resData = await blobToData(blob)
        // console.log(resData);
         
        return {success: false, data:null, message:resData, tokenExpired:false}
      }
    } catch (error) {
        console.log('API call failed')
        console.error(error);
    }
},

}

export default APIAdapter;


export const blobToData = (blob: Blob) => {
  return new Promise((resolve) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result)
    reader.readAsText(blob)
  })
}